import Mixpanel from 'common/services/stats/-RFC.Mixpanel';
import { AppPricesProcessor } from 'common/repositoryProcessors/index';
import { FlexiblePromotionsRepository } from 'common/repositories/index';


const _serviceDependencies = ['$scope', '$rootScope', '$state', 'Util'];

class TrialModal {

    constructor($scope, $rootScope, $state, Util) {

        $scope.trialPromotion = FlexiblePromotionsRepository.getPromotionById('prime_anual_trial');
        $rootScope.primeTrialShopUrl = $scope.trialPromotion.attributes.promotion_url;

        if (!$scope.trialPromotion) {

            Util.closeModal();

        }

        const mixpanelPayload = {
            Source: 'Trial 60 Days',
            Modal: 'Prime 60 Days Trial',
            Product: 'aps10',
            Page: Util.getPageName(),
        };

        Mixpanel.send('ConnectWeb Modal Open ', mixpanelPayload);

        // Save the trial timeline object
        // Calculate the last day of trial based on the runtime value
        const runtime = 60;
        const trialEndDate =
            new Date(new Date().setDate(new Date().getDate() + runtime));

        // Calculate the reminder date based on the runtime value and the reminder email days
        const reminderEmailDays = 15;
        const reminderEmailDate = new Date(new Date()
            .setDate((new Date().getDate() + runtime) - reminderEmailDays));

        $scope.trialTimeline = {
            startDate: new Date().getDate(),
            startMonth: new Date().getMonth() + 1,
            endDate: trialEndDate.getDate(),
            endMonth: trialEndDate.getMonth() + 1,
            reminderDate: reminderEmailDate.getDate(),
            reminderMonth: reminderEmailDate.getMonth() + 1,
        };

        $scope.checkPayNowPrice = () => {

            const repoPrice = AppPricesProcessor.getSinglePrice('aps10', '12', '1');

            // Regular price
            let price = repoPrice.attributes.promotion.total_price_string;

            // Check digit positions
            const regex = new RegExp('\\d', 'g');
            let digit;
            const positions = [];
            // eslint-disable-next-line no-cond-assign
            while (digit = regex.exec(price)) {

                positions.push(digit.index);

            }

            // Save the pay now price in the price_string format
            price = (positions[0] === 0) ?
                '0'.concat(price.substring(positions[positions.length - 1] + 1)) :
                price.substring(0, positions[0]).concat('0');

            return price;

        };

        // CMA Links
        const currentLanguage = CWCONFIG.language;
        const configSupportLanguages = CWCONFIG.cma.subscriptions.supportLanguages;
        let redirectSupportLanguage = '';

        if (configSupportLanguages.find(lang => lang === currentLanguage)) {

            if (currentLanguage === 'en') {

                redirectSupportLanguage = 'en-us';

            } else {

                redirectSupportLanguage = currentLanguage;

            }

        } else {

            redirectSupportLanguage = 'en-us';

        }

        $scope.siteLink = CWCONFIG.cma.subscriptions.siteLink.replace(/\[language\]/gi, currentLanguage);
        $scope.globalPrivacy = CWCONFIG.cma.subscriptions.globalPrivacy.replace(/\[language\]/gi, currentLanguage);
        $scope.termsOfSale = CWCONFIG.cma.subscriptions.termsOfSale.replace(/\[language\]/gi, currentLanguage);
        $scope.licenseAgreement = CWCONFIG.cma.subscriptions.licenseAgreement.replace(/\[language\]/gi, currentLanguage);
        $scope.cancellation = CWCONFIG.cma.subscriptions.tooltip.cancellationPolicy.replace(/\[language\]/gi, currentLanguage);
        $scope.contactUs = CWCONFIG.cma.subscriptions.tooltip.contactUs.replace(/\[language\]/gi, redirectSupportLanguage);
        $scope.learnHow = CWCONFIG.cma.subscriptions.learnHow.replace(/\[language\]/gi, currentLanguage);
        $scope.cancelOrRefund = CWCONFIG.cma.subscriptions.cancelOrRefund.replace(/\[language\]/gi, currentLanguage);
        $scope.yourAccount = CWCONFIG.cma.subscriptions.yourAccount.replace(/\[language\]/gi, currentLanguage);
        $scope.cancelContractDetails = CWCONFIG.cma.subscriptions.cancelContractDetails.replace(/\[language\]/gi, redirectSupportLanguage);
        $scope.cancelContractDetailsNew = CWCONFIG.cma.subscriptions.cancelContractDetailsNew.replace(/\[language\]/gi, redirectSupportLanguage);
        // End CMA links

        $scope.showCMAscreen = false;

        $scope.showCMAscreenClick = () => {

            $scope.showCMAscreen = true;

        };

        $scope.backToTrialScreen = () => {

            $scope.showCMAscreen = false;

        };

        $scope.activateTrial = () => {

            const mixpanelDetails = {
                Modal: 'Prime 60 Days Trial',
                'Button Label': 'Start trial',
                Product: 'Prime 60 Days Trial',
                'Product ID': 'aps10',
                Page: Util.getPageName(),
            };

            Mixpanel.send('ConnectWeb Modal Button Click', mixpanelDetails);

            $state.go($state.current.name, {
                ltb: 'payment-cart',
                resourceId: 'aps10',
                trial: true,
            });

            sessionStorage.setItem('trialModalClosed', 'true');

        };

    }

}

_serviceDependencies.push(TrialModal);

angular.module('controllers')
    .controller('TrialModal', _serviceDependencies);



// WEBPACK FOOTER //
// ./scripts/controllers/modals/trial-modal/trial-modal.js